// ================================================================
// Node Registry — ثبت تمام nodeها
// ================================================================

import { startDefinition } from './start/definition.js';
import { bexioDefinition } from './bexio/definition.js';
import { emailDefinition } from './email/definition.js';
import { phoneDefinition } from './phone/definition.js';
import { whatsappDefinition } from './whatsapp/definition.js';
import { voiceDefinition } from './voice/definition.js';
import { aiAnalysisDefinition } from './ai-analysis/definition.js';
import { dummyDefinitions } from './_dummy.js';

const registry = new Map();

function register(definition) {
  registry.set(definition.type, definition);
}

// nodeهای واقعی
register(startDefinition);
register(bexioDefinition);
register(emailDefinition);
register(phoneDefinition);
register(whatsappDefinition);
register(voiceDefinition);
register(aiAnalysisDefinition);

// nodeهای dummy (فقط نمایشی)
dummyDefinitions.forEach(register);

// API
export const nodeRegistry = {
  get(type) {
    return registry.get(type);
  },

  getAll() {
    return Array.from(registry.values());
  },

  /**
   * nodeهایی که در picker نشون داده می‌شن (Start مخفی هست)
   */
  getPickerItems() {
    return Array.from(registry.values()).filter(d => !d.hideFromPicker);
  },

  /**
   * فیلتر بر اساس category
   */
  getByCategory(category) {
    return this.getPickerItems().filter(d => d.category === category);
  },

  getTypes() {
    return Array.from(registry.keys());
  }
};
